import React, { useState, useEffect, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Field, reduxForm, change, formValueSelector } from 'redux-form';
import withStyles from 'isomorphic-style-loader/withStyles';
import cx from 'classnames';
import {
  Button,
  FormGroup,
  Col,
  Row,
  Panel,
} from 'react-bootstrap';

import submit from './submit';
import validate from './validate';
import { useIntl, FormattedMessage } from 'react-intl';
import InputFieldComponent from '../../Common/FormField/InputFieldComponent';
import SelectFieldComponent from '../../Common/FormField/SelectFieldComponent';
import Link from '../../Link';
import { url } from '../../../config.js';
import { formatURL } from '../../../helpers/formatURL';
import Loader from '../../Loader/Loader.js';

import messages from '../../../locale/messages';
import bt from '../../../components/commonStyle.css';

import s from './AddBlogDetails.css';


const RenderQuill = ({ input, meta: { touched, error }, placeholder }) => {
  const intl = useIntl();
  const [Editor, setEditor] = useState(null);
  useEffect(() => {
    if (typeof window !== 'undefined') {
      import('../../Common/Editor/CustomEditor').then(mod => setEditor(() => mod.Editor));
    }
  }, []);
  return (
    Editor &&
    <div>
      <Editor
        {...input}
        placeholder={placeholder}
      />
      {touched && error && <span className={s.errorMessage}>{intl.formatMessage(error)}</span>}
    </div>
  )
}

function AddBlogDetails({ handleSubmit, submitting, error }) {
  const intl = useIntl();
  const dispatch = useDispatch();

  const [isClient, setClient] = useState(false);

  const siteName = useSelector(state => state.siteSettings.data.siteName);

  const handlePageTitle = async (e) => {
    if (e.target.value) {
      await dispatch(change('BlogDetails', 'pageUrl', formatURL(e.target.value)));
    } else {
      await dispatch(change('BlogDetails', 'pageUrl', ''));
    }
  };

  useEffect(() => {
    if (typeof window !== 'undefined') {
      setClient(true)
    }
  }, []);

  return (
    isClient ?
      <div>
        <h1 className={s.siteAdminHeading}>{intl.formatMessage(messages.addPageLabel)}</h1>
        <Row>
          <Col xs={12} sm={12} md={12} lg={8} className={s.blockCenter}>

            <div className={cx(s.space4, 'singleButtonFlexEnd')}>
              <Link
                to="/siteadmin/content-management"
                className={cx(bt.btnPrimaryBorder, bt.btnLarge, bt.noTextDecoration)}
              >
                <FormattedMessage {...messages.goBack} />
              </Link>
            </div>

            <Panel className={cx(s.panelHeader)}>
              <form onSubmit={handleSubmit(submit)}>
                {error && <strong>{intl.formatMessage(error)}</strong>}

                <Field
                  name="metaTitle"
                  type="text"
                  component={InputFieldComponent}
                  label={intl.formatMessage(messages.metaTitleLabel)}
                  placeholder={intl.formatMessage(messages.metaTitlePlaceHolder)}
                  inputClass={bt.commonControlInput}
                  formGroupClass={bt.space4}
                />

                <Field
                  name="metaDescription"
                  inputClass={bt.commonControlTextArea}
                  formGroupClass={bt.space4}
                  component={InputFieldComponent}
                  componentClass="textarea"
                  label={intl.formatMessage(messages.metaDescriptionLabel)}
                  placeholder={intl.formatMessage(messages.metaDescriptionPlaceHolder)}
                />

                <Field
                  name="pageTitle"
                  type="text"
                  component={InputFieldComponent}
                  inputClass={bt.commonControlInput}
                  formGroupClass={bt.space4}
                  label={intl.formatMessage(messages.pageTitleLabel)}
                  placeholder={intl.formatMessage(messages.pageTitlePlaceHolder)}
                  onChange={handlePageTitle}
                />

                <Field
                  name="pageUrl"
                  type="text"
                  component={InputFieldComponent}
                  isAddon
                  suffixLabel={`${url}${intl.formatMessage(messages.pageLabel)}`}
                  label={intl.formatMessage(messages.pageUrl)}
                  placeholder={intl.formatMessage(messages.pageUrlExample)}
                  inputClass={cx(bt.commonControlInput, 'staticPageUrlInput')}
                  formGroupClass={cx("staticPageUrl", bt.space4)}
                />

                <Field
                  name="footerCategory"
                  inputClass={cx(bt.commonControlSelect, 'commonControlSelectRtl')}
                  formGroupClass={bt.space4}
                  component={SelectFieldComponent}
                  label={intl.formatMessage(messages.footerCategoryLabel)}
                  options={[
                    { value: '', label: intl.formatMessage(messages.ChooseFooterCategory) },
                    { value: siteName, label: siteName },
                    { value: 'discover', label: intl.formatMessage(messages.discover) },
                    { value: 'hosting', label: intl.formatMessage(messages.hosting) },
                  ]}
                />
                <FormGroup className={bt.space4}>
                  <label className={s.labelTextNew}>
                    <FormattedMessage {...messages.contentLabel} />
                  </label>
                  <Field name="content" component={RenderQuill} placeholder={intl.formatMessage(messages.contentPlaceHolder)} />
                </FormGroup>
                <div className='singleButtonFlexEnd'>
                  <Button className={cx(bt.btnPrimary, bt.btnLarge)} type="submit" disabled={submitting}>
                    <FormattedMessage {...messages.save} />
                  </Button>
                </div>
              </form>
            </Panel>
          </Col>
        </Row>
      </div> : <Loader type={"text"} />

  );
}

AddBlogDetails.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
  error: PropTypes.any,
};

export default reduxForm({
  form: 'BlogDetails',
  validate,
})(withStyles(s, bt)(AddBlogDetails));
